import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import axios from 'axios'

const BAD_IMAGES = {}

const Inline = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
`

const Image = styled.img`
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  background-color: white;
  border-radius: 50%;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075);
`

// const StyledEthereumLogo = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   > img {
//     width: ${({ size }) => size};
//     height: ${({ size }) => size};
//   }

//   > svg {
//     width: ${({ size }) => size};
//     height: ${({ size }) => size};
//   }
// `

export default function TokenLogo({ address, header = false, size = '24px', ...rest }) {
  const [error, setError] = useState(false)
  const [imgURI, setImgURI] = useState('')

  useEffect(() => {
    const fetch = async () => {
      const { data } = await axios.get('https://tokens.empiredex.org/tokenlist.json')
      const filteredAddress = data.tokens.filter((element) => element.address.toLowerCase() === address.toLowerCase())
      const URI = filteredAddress.filter((element) => element.chainId === 43114)
      if (URI.length > 0) {
        const { logoURI } = URI[0]
        setImgURI(logoURI)
      }
    }

    fetch()

    setError(false)
  }, [address])

  if (error || BAD_IMAGES[address] || imgURI === '') {
    return (
      <Inline>
        <span {...rest} alt={''} style={{ fontSize: size }} role="img" aria-label="face">
          🤔
        </span>
      </Inline>
    )
  }

  return (
    <Inline>
      <Image
        {...rest}
        alt={''}
        src={imgURI}
        size={size}
        onError={(event) => {
          BAD_IMAGES[address] = true
          setError(true)
          event.preventDefault()
        }}
      />
    </Inline>
  )
}
